import { confirmable } from 'react-confirm';
import { ConfirmDialog } from './confirm-dialog';

interface ICallableConfirmDialogProps {
  show: boolean;
  proceed: (value?: boolean) => void;
  confirmation: string;
  options?: string;
}

export const CallableConfirmDialog = confirmable(
  ({ show, proceed, confirmation }: ICallableConfirmDialogProps) => {
    return (
      <ConfirmDialog
        show={show}
        title="Confirm Navigation"
        content={confirmation}
        onCancel={() => {
          proceed(true);
        }}
        onConfirm={() => proceed(false)}
        confirmButtonText="Yes"
        cancelButtonText="No"
      />
    );
  }
);
